import { IUser } from 'app/containers/Authorization/slice/types';

/* --- STATE --- */
export interface HiikoEnvState {
  selectedEnvId: number | null;
  envs: IEnv[];
  initLoading: boolean;
  createEnvLoading: boolean;
  isCreateEnvFormVisible: boolean;
}

export interface IEnv {
  countryCode: string;
  id: number;
  name: string;
  user: IUser;
  role: 'OWNER' | 'SHARED' | null;
  archived: boolean;
}

export enum createEnvFormEnum {
  envName = 'envName',
  countryCode = 'countryCode',
}

export interface ICreateEnvPayload {
  countryCode: string;
  envName: string;
}
